import generator from "generate-password";
import PasswordValidator from "password-validator";
export function digestMessage(message) {
  const encoder = new TextEncoder();
  const data = encoder.encode(message);
  return window.crypto.subtle.digest('SHA-256', data);
}
export function hexString(buffer) {
  if (buffer != null) {
    const byteArray = new Uint8Array(buffer);
    const hexCodes = [...byteArray].map(value => {
      const hexCode = value.toString(16);
      const paddedHexCode = hexCode.padStart(2, '0');
      return paddedHexCode;
    });
    return hexCodes.join('');
  } else {
    return '';
  }
}
export async function generateRandomPassword() {
  const password = generator.generate({
    length: PASSWORD_MIN_LENGTH,
    numbers: true,
    // add numbers to the password
    uppercase: true,
    // add uppercase to the password
    excludeSimilarCharacters: true,
    // don't include stuff like l and i
    strict: true // require one of each above rule
  });
  return password;
}
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 30;
export function validateUserDefinedPassword(password) {
  const schema = new PasswordValidator();
  schema.is().min(PASSWORD_MIN_LENGTH) // must be 10 characters in length
  .is().max(PASSWORD_MAX_LENGTH) // arbitrarily set max length to 30
  .has().uppercase() // Must have uppercase
  .has().lowercase() // Must have lowercase
  .has().digits() // Must have a number
  .has().not().spaces(); // No whitespace

  return schema.validate(password, {
    list: true
  });
}